import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  filter: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2)
  }
}));

export default function FilterContainer ({ children, ...props }) {
  const classes = useStyles();

  return (
    <div className={classnames(classes.filter, 'nr-filter-toolbar')}>
      {children}
    </div>
  );
}
